import { Entity, makeClone } from 'gossamer-unified';
import { EventFeedback, EventFeedbackRow } from './EventFeedback';
import { EVENTS_I_HOST } from './SecurityRules';

export type EventFeedbackAnonymousViewRow = Omit<EventFeedbackRow, 'submitter_user_id'>;

const clone = makeClone();

export const EventFeedbackAnonymousView: Entity<EventFeedbackAnonymousViewRow> = {
  id: 'EventFeedbackAnonymousView',
  title: 'Event Feedback Anonymous View',
  service: 'main',
  rowLabel: (row: EventFeedbackAnonymousViewRow) => String(row.id),
  rowLabelDynamic: undefined,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.event_feedback_anonymous_view',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HOST}`,
    },
  ],
  defaultSort: EventFeedback.defaultSort,
  defaultFilters: EventFeedback.defaultFilters,
  listRowLink: EventFeedback.listRowLink,
  fields: {
    id: clone(EventFeedback.fields.id),
    event_id: clone(EventFeedback.fields.event_id),
    feedback_form_id: clone(EventFeedback.fields.feedback_form_id),
    content_score: clone(EventFeedback.fields.content_score),
    delivery_score: clone(EventFeedback.fields.delivery_score),
    admin_score: clone(EventFeedback.fields.admin_score),
    overall_score: clone(EventFeedback.fields.overall_score),
    additional_comments: clone(EventFeedback.fields.additional_comments),
    responses: clone(EventFeedback.fields.responses),
    created_at: clone(EventFeedback.fields.created_at),
  },
};
